import React, { useEffect, useState } from "react";

import { useRecoilState } from "recoil";
import { StudioSession } from "../../../State/studioSession";

import { RemixProcessing } from "./Components/RemixProcessing";

import { StudioView } from "../StudioView";
import { ModalType, TStudioProps } from "../../../@types";
import { hasScope } from "../../../Utilities/Studio";
import { useIsMobileApp } from "../../../Hooks/useIsMobileApp";
import { AllstarModalState } from "../../../State/modals";

interface IRemixProps extends TStudioProps {
  postRemix: () => any;
}

export const RemixView = ({
  modal,
  setModal,
  clear,
  query,
  onQuery,
  handleCardClick,
  facetLoading,
  cardsData,
  cardClips,
  creatorCardModal,
  setCreatorCardModal,
  allstarUser,
  getFreshProfile,
  singleCardData,
  remixData,
  banner,
  postRemix,
  logout,
  pageNav,
  mutateFollowers,
}: IRemixProps) => {
  const [studioSession, setStudioSession] = useRecoilState(StudioSession);
  const [allstarModalState, setAllstarModalState] =
    useRecoilState(AllstarModalState);
  const { isMobileApp } = useIsMobileApp();

  useEffect(() => {
    window.onbeforeunload = function () {
      if (studioSession.userActivated.length) {
        return "Sure you wanna refresh?";
      }
    };
    return () => {
      window.onbeforeunload = null;
    };
  }, [studioSession.userActivated.length]);

  useEffect(() => {
    window.rudderanalytics.page("Studio", "Remix View");
  }, []);

  useEffect(() => {
    if (studioSession.confirmedClear && allstarUser.loggedIn) {
      setModal({ type: "" });
      setStudioSession({
        ...studioSession,
        confirmedClear: false,
        userActivated: [],
      });
    }
  }, [studioSession.confirmedClear]); //eslint-disable-line

  // intercept toggle for cards on remix:
  const handleCardToggleRemix = (
    card: Record<string, any>,
    isActive: boolean,
  ) => {
    if (!allstarUser.loggedIn) {
      window.rudderanalytics.track(`Allstar Studio - Visitor Attempt Toggle`);
      setAllstarModalState({
        ...allstarModalState,
        isOpen: ModalType.Signup,
        data: {
          action: "signup",
        },
      });
      return false;
    }

    if (!hasScope(allstarUser.user, card.scopeUse) && card.ui.badge === "top") {
      setModal({ type: "top" });
      return false;
    }

    if (!hasScope(allstarUser.user, card.scopeUse)) {
      setModal({ type: card.ui.rarity });
      return false;
    }

    if (isActive) {
      setStudioSession({
        ...studioSession,
        userActivated: [...studioSession.userActivated, card],
      });
    } else {
      setStudioSession({
        ...studioSession,
        userActivated: studioSession.userActivated.filter(
          (x: any) => x._id !== card._id,
        ),
      });
    }
    window.rudderanalytics.track(`Creator Card Toggle`, {
      title: card?.ui?.title,
      cardId: card?._id,
      state: isActive ? "on" : "off",
      isAndroidApp: isMobileApp,
      remix: true,
    });
    return true;
  };

  const handleToggleAll = (
    isActive: boolean,
    category?: String,
    cards?: any,
  ) => {
    if (!allstarUser.loggedIn) {
      setAllstarModalState({
        ...allstarModalState,
        isOpen: ModalType.Signup,
        data: {
          action: "signup",
        },
      });
      return false;
    }
    const cardsToToggle = cards ? cards : studioSession.hits;
    if (isActive) {
      setStudioSession({
        ...studioSession,
        userActivated: [...studioSession.userActivated, ...cardsToToggle],
      });
    } else {
      setStudioSession({
        ...studioSession,
        userActivated: studioSession.userActivated.filter((x: any) => {
          return !cardsToToggle
            .map((y: any) => {
              return y._id;
            })
            .includes(x._id);
        }),
      });
    }

    return true;
  };

  if (studioSession.remixQueued) {
    return <RemixProcessing />;
  }

  if (!remixData?.moment) {
    return <></>;
  }

  return (
    <>
      <StudioView
        modal={modal}
        setModal={setModal}
        clear={clear}
        query={query}
        onQuery={onQuery}
        handleCardClick={handleCardClick}
        handleCardToggle={handleCardToggleRemix}
        facetLoading={facetLoading || cardsData.loading}
        cardsData={cardsData}
        cardClips={cardClips}
        creatorCardModal={creatorCardModal}
        singleCardData={singleCardData}
        setCreatorCardModal={setCreatorCardModal}
        allstarUser={allstarUser}
        getFreshProfile={getFreshProfile}
        banner={banner}
        logout={logout}
        pageNav={pageNav}
        mutateFollowers={mutateFollowers}
        remixData={remixData}
        handleToggleAll={handleToggleAll}
        postRemix={postRemix}
      />
    </>
  );
};
